import { API_BASE_URL_ENV } from "../../jsx/common/common";
import BaseService from "../BaseService";

const apiEndpoint = API_BASE_URL_ENV() + "/company-policies";

export default class CompanyPolicyService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
